import { Injectable } from '@angular/core';
import axios, { AxiosError } from 'axios';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceService {

  constructor() { }

  async getMaintenanceConfig() {
    return await axios.get('assets/configurations/maintenance-config.json')
      .then((response) => {
        return response;
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

}
